<template>
  <Modal :activeModal="activeModal" @closeModal="closeModal">
    <template v-slot:btnActivator>
      <v-btn tile :color="variables.colorPrimary" dark class="mb-2 modal-cadastro-btn-cadastrar" @click="openModal"
        :loading="loadingBtnCadastro">Novo cadastro</v-btn>
    </template>
    <v-card>
      <v-toolbar flat height="40px" class="modal-cadastro-toolbar">
        {{ isEdit ? `Editar Configurações: ${item.name} ` : 'Cadastrar Despesas' }}
        <v-spacer></v-spacer>
        <v-icon @click="closeModal" class="modal-cadastro-close">close</v-icon>
      </v-toolbar>

      <v-form>
        <v-card-text class="modal-cadastro-form">
          <v-row v-show="!loadingAllModal">
            <v-col cols="11" class="pt-0">
              <v-row>
                <!-- Afiliado -->
                <v-col cols="9" class="modal-cadastro-form-col-imput">
                  <ParentAffiliate :key="keyConfig"
                    v-if="permiteAcao({ path: '/afiliados/afiliados/get-all-affiliates/' }, '')"
                    :affiliateId="this.item.affiliate" ref="parentAffiliate" :disabledEdit="isEdit"
                    :errorMessages="affiliateErrors" />
                </v-col>
              </v-row>
              <v-col cols="11" class="pt-0">
                <v-row>
                  <!-- Depósito -->
                  <v-col cols="2" class="modal-cadastro-form-col-imput">
                    <v-currency-field v-model="item.txDeposit" label="Taxa de Depósitos:" prefix="%" dense
                      :error-messages="depositErrors" @input="$v.item.txDeposit.$touch()"
                      @blur="$v.item.txDeposit.$touch()" />
                  </v-col>
                  <!-- Saques -->
                  <v-col cols="2" class="modal-cadastro-form-col-imput">
                    <v-currency-field v-model="item.txWithdraw" label="Taxa de Saques:" prefix="%" dense
                      :error-messages="drawErrors" @input="$v.item.txWithdraw.$touch()"
                      @blur="$v.item.txWithdraw.$touch()" />
                  </v-col>
                  <!-- Custos -->
                  <v-col cols="2" class="modal-cadastro-form-col-imput">
                    <v-currency-field v-model="item.txCosts" label="Taxa de Custos:" prefix="%" dense
                      :error-messages="costsErrors" @input="$v.item.txCosts.$touch()"
                      @blur="$v.item.txCosts.$touch()" />
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
          </v-row>
          <div class="text-center" v-show="loadingAllModal">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-card-text>

        <v-card-actions class="modal-cadastro-footer">
          <v-btn tabindex="7" :color="variables.colorPrimary" @click="closeModal"
            class="br-btn br-btn-cancelar">Cancelar</v-btn>
          <v-btn tabindex="6" type="submit" :color="variables.colorPrimary" @click.prevent="cadastrarDespesas()"
            class="br-btn" :loading="loading">{{ isEdit ? 'Salvar' : 'Cadastrar' }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
// eslint-disable-next-line
import { maxValue, minValue, required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import Events from '@/core/service/events'
import variables from '@/assets/styles/helpers/_variables.scss'
import moment from 'moment'
moment.locales('pt-br')

// eslint-disable-next-line
import { map } from 'lodash'
import { errorSnackbar, successSnackbar } from '@/core/service/utils'
import validacao from './validacao'
// eslint-disable-next-line
export default {
  name: 'ModalCadastroPlanosAfiliado',
  mixins: [validationMixin],
  directives: { mask },

  components: {
    Modal: () => import('@/views/components/modal'),
    ParentAffiliate: () => import('./parentAffiliate'),
  },

  data: () => ({
    loadingTableValues: false,
    activeModal: false,
    loading: false,
    loadingAllModal: false,
    loadingBtnCadastro: false,
    keyConfig: 1,
  }),

  watch: {
    'item.txDeposit'(val) {
      if (val > 100) this.$nextTick(() => { this.item.txDeposit = 100 })
    },
    'item.txCosts'(val) {
      if (val > 100) this.$nextTick(() => { this.item.txCosts = 100 })
    },
    'item.txWithdraw'(val) {
      if (val > 100) this.$nextTick(() => { this.item.txWithdraw = 100 })
    }
  },

  computed: {
    ...mapGetters('expenseConfigs', ['item', 'itens', 'getCadastroExistente']),
    ...mapGetters('expenseConfigs', {
      getParentIdAffiliate: 'getParentIdAffiliate'
    }),
    ...mapGetters('roles', ['permiteAcao']),
    ...validacao,
    variables: () => variables,
    isEdit() {
      return this.item.id ? !!1 : !!0
    },
  },
  mounted() {
    Events.$on('expenseConfigs::consultaCompletaAfiliado', () => {
      this.loadingAllModal = false
    })
    Events.$on('cadastro::openModalCadastro', (dados) => {
      this.loadingAllModal = true
      this.openModal(dados)
    })
  },
  methods: {
    ...mapActions('expenseConfigs', ['cadastrarItem', 'editarItem', 'limparItem', 'clearModal', 'getItens', 'setItem', 'setCadastroExistente']),

    async openModal() {
      this.activeModal = true
      this.keyConfig += 1
    },

    async cadastrarDespesas(subscribeRegister = null) {
      if (this.$v.item.$invalid) {
        this.$v.item.$touch()
        return false
      }

      this.loading = true
      const obj = {
        affiliateId: this.item.affiliate,
        txDeposit: this.item.txDeposit,
        txCosts: this.item.txCosts,
        txWithdraw: this.item.txWithdraw,
        replaceExpense: this.isEdit,
        subscribeRegister: subscribeRegister
      }

      // Edita e cadastra item
      if (this.isEdit) {
        obj.id = this.item.id
        obj.subscribeRegister = subscribeRegister
        this.editarItem(obj)
          .then(() => {
          successSnackbar('Cadastro atualizado com sucesso!')
          this.closeModal()
          Events.$emit('reload::table::index')
        }).catch(err => {
          if (err.error === 'Registro na mesma data!') {
            this.$swal({
              icon: 'warning',
              text: `Tem certeza que deseja editar? essa edição excluirá esse registro e gerará um novo que será válido a partir da data de hoje.`,
              showCancelButton: true,
              confirmButtonText: 'Sim',
              cancelButtonText: 'Não',
            }).then((result) => {
              if (result.value) {
                this.cadastrarDespesas(true)
              }
            })
            return 
          }
          errorSnackbar(err.error)
        }).finally(() => {
          this.loading = false
        })
      } else {
        // Cadastra o item
        this.editarItem(obj).then((res) => {
          if (res.data.data === 'despesa_jah_existe') {
            this.setCadastroExistente(true)
            this.cadastroExistente(obj)
          } else {
            if (this.isEdit) successSnackbar('Cadastro atualizado com sucesso!')
            if (!this.isEdit) successSnackbar('Cadastro efetuado com sucesso!')
            this.closeModal()
            Events.$emit('reload::table::index')
            this.loading = false
          }
        }).catch((err) => { 
          errorSnackbar(err.error)
          this.loading = false
        })
      }
    },

    closeModal() {
      this.activeModal = false
      this.limparItem()
      this.clearModal()
      this.$v.item.$reset()
    },

    async cadastroExistente(obj) {
      if (this.getCadastroExistente) {
        obj.replaceExpense = this.getCadastroExistente
        obj.subscribeRegister = this.getCadastroExistente
        this.$swal({
          icon: 'warning',
          text: `Tem certeza que deseja Cadastrar? Já existe um cadastro para este afiliado, essa cadastro excluirá o registro existente e gerará um novo que será válido a partir da data de hoje.`,
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
        }).then((result) => {
          if (result.value) {
            this.editarItem(obj).then(() => {
              successSnackbar('Cadastro atualizado com sucesso!')
              this.closeModal()
              Events.$emit('reload::table::index')
            }).catch(err => errorSnackbar(err.error))
              .finally(() => {
                this.loading = false
              })
          } else {
            this.loading = false
          }
        })
      }
    },
  },

  validations() {
    return {
      item: {
        affiliate: { required },
        txDeposit: { required, minValue: minValue(0) },
        txCosts: { required, minValue: minValue(0) },
        txWithdraw: { required, minValue: minValue(0) },
      },
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../../../assets/styles/components/formularios';
@import '../../../../assets/styles/components/modal-cadastro';
// .modal-cadastro-form . {
//   border: 1px solid black;
//   padding: 5px;
//   border-radius: 10px;
// }

.input-level {
  text-align-last: center;
}

table tbody tr td span {
  background: cadetblue;
  width: 50px;
  border-radius: 10px;
  min-width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
  font-size: 18px;

  &:hover {
    opacity: 0.8;
  }
}

.contrato {
  margin: 0 !important;
  padding: 0 !important;
}
</style>